import React, { useState, useEffect, useRef } from 'react';
import './LiveStreamWidget.css';
import ReactDOM from 'react-dom';

const LiveStreamWidget = ({ config }) => {
  const [isLive, setIsLive] = useState(false);
  const [streamUrl, setStreamUrl] = useState('');
  const [showWidget, setShowWidget] = useState(false);
  const playerRef = useRef(null);
  const wsRef = useRef(null);
  
  useEffect(() => {
    const checkStreamStatus = async () => {
      try {
        const response = await fetch(`${config.backendUrl}/api/stream-status/${config.companyId}`);
        const data = await response.json();
        setIsLive(data.live_status);
        if (data.stream_id) {
          setStreamUrl(`https://www.youtube.com/embed/${data.stream_id}?autoplay=1&mute=1`);
        }
      } catch (error) {
        console.error('Error checking stream status:', error);
      }
    };

    checkStreamStatus();
  }, [config.backendUrl, config.companyId]);

  // Make sure we're not returning null when we should show
  if (!config.showWidget && !isLive) {
    return null;
  }

  if (!isLive || !streamUrl) {
    return (
      <div className="livestream-widget offline">
        <div className="livestream-offline-content">
          <h3>Stream is currently offline</h3>
          <p>Check back later or schedule a meeting!</p>
        </div>
      </div>
    );
  }

  return (
    <div className="livestream-widget">
      <div className="livestream-container">
        <div className="livestream-live-indicator">
          <span className="livestream-live-dot"></span>
          LIVE
        </div>
        <iframe
          ref={playerRef}
          src={streamUrl}
          frameBorder="0"
          allowFullScreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          referrerPolicy="origin"
        />
      </div>
    </div>
  );
};

const init = (selector, config) => {
  if (!config.companyId || !config.apiKey || !config.backendUrl) {
    throw new Error('Missing required configuration (companyId, apiKey, or backendUrl)');
  }

  const container = document.querySelector(selector);
  if (!container) {
    throw new Error(`Container element "${selector}" not found`);
  }

  ReactDOM.render(
    <LiveStreamWidget config={config} />,
    container
  );
};

// Export for standalone script usage
if (typeof window !== 'undefined') {
  window.LiveStreamWidget = { init };
}

// Single export statement
export { LiveStreamWidget, init }; 